/**
 * Envision Customizations
 * assets/blog.js
 *
 * Custom JavaScript
 */

/**
 * Add a "Filter by" label above the "Recipe Kit" app filters once they're loaded
 */

// Wait for Recipe Kit filters to load in the DOM, then add a "Filter by" label above them
(function() {
  const filterByLabelText = 'Filter by:';
  const filterByLabelClass = 'filter-by-label';
  const filterContainerId = 'rk_filter';

  function addFilterByLabel(container) {
    const filterByLabel = document.createElement('div');
    filterByLabel.textContent = filterByLabelText;
    filterByLabel.className = filterByLabelClass;
    container.insertBefore(filterByLabel, container.firstChild);
  }

  waitForElm(`#${filterContainerId}`).then((recipeKitFilters) => {
    addFilterByLabel(recipeKitFilters);
  });
})();